import { staggerContainer, staggerItem, viewportOptions } from '@/lib/animations';
import { motion } from 'framer-motion';
import { ClipboardCheck, FileCheck, Home } from 'lucide-react';

export default function Features() {
  const steps = [
    {
      icon: ClipboardCheck,
      number: 1,
      title: 'Build Your Listing',
      description: 'Launch in 15 minutes with AI-crafted descriptions and enhanced photos. No stress, No second-guessing.',
    },
    {
      icon: Home,
      number: 2,
      title: 'Go Live Everywhere',
      description: 'Your home hits MLS, Zillow, Redfin, attracting serious buyers who see it fast and start booking showings.',
    },
    {
      icon: FileCheck,
      number: 3,
      title: 'Close Smoothly',
      description: 'Handle offers, paperwork, and deadlines in one place. No chaos, no commission. Just a clean, confident close.',
    },
  ];

  return (
    <section>
      <motion.div 
        className="text-center mb-16"
        variants={staggerContainer}
        initial="hidden"
        whileInView="visible"
        viewport={viewportOptions}
      >
        <motion.h3 className="landing-title" variants={staggerItem}>How It Works</motion.h3>
        <motion.p className="landing-subtitle" variants={staggerItem}>Selling made so easy, it's like floating down a lazy river</motion.p>
      </motion.div>
      <div className="mx-auto px-4 relative">
        <div className="hidden md:block absolute top-7 left-[16%] right-[16%] h-1 bg-brand-light z-0"></div>

        <motion.div 
          className="relative z-10 flex flex-col md:flex-row justify-between items-start"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOptions}
        >
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex flex-col items-center mb-10 md:mb-0 md:w-1/3 px-4"
              variants={staggerItem}
            >
              <div
                className="size-14 rounded-full shadow-md flex items-center justify-center z-10 bg-brand"
              >
                <span className="text-white text-xl font-bold">{step.number}</span>
              </div>

              <div className="text-center px-4 mt-4">
                <h4 className="text-lg font-bold mb-4">{step.title}</h4>
                <p className="text-sm md:text-base flex items-center justify-center text-center">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
